import React from "react";

import { useTranslation } from "react-i18next";

import { Controller, useFormContext } from "react-hook-form";

import InputWithAddOptions from "@components/input/InputWithAddOptions";

import useAdvantageType from "../../../hooks/useAdvantageType";

export default function InputAdvantageTitle(props) {
  const { t: translate } = useTranslation([
    "pages.employés.parcours&Certifications",
    "message"
  ]);

  const { readOnly = false, index = 0 } = props;

  const {
    advantageTypes,
    addAdvantageType,
    updateAdvantageType,
    deleteAdvantageType
  } = useAdvantageType();

  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={`AdvantageType.${index}`}
      rules={{
        required: true,
        validate: {
          isAdvantageTypeValid: (value) =>
            value?.name && value.name.trim() !== ""
        }
      }}
      render={({
        field: { onChange, value, name },
        fieldState: { invalid }
      }) => (
        <>
          <label
            className={`arh-mb-1 arh-flex arh-w-full arh-font-poppins arh-text-xs arh-font-medium ${
              readOnly
                ? "arh-text-greyDisabledText"
                : invalid
                  ? "arh-text-[#F60A20]"
                  : "arh-text-black"
            }`}
          >
            {translate("Type d'avantage")}
          </label>
          <InputWithAddOptions
            name={name}
            value={
              advantageTypes.find((item) => item?._id === value?._id)?.name ||
              value?.name
            }
            onChange={(event) => {
              const newData = event?.target?.dataset;
              if (newData) {
                onChange({
                  ...value,
                  _id: newData.id || "",
                  name: newData.value || ""
                });
              }
            }}
            disabled={readOnly}
            defaultText={translate("Type d'avantage")}
            defaultSelected={value?._id}
            optionsList={advantageTypes}
            secondDefaultText={translate("Ajouter")}
            optionListLabel="name"
            addItem={(data) => addAdvantageType(data)}
            editItem={(data) => updateAdvantageType(data)}
            deleteItem={(data) => deleteAdvantageType(data)}
            validateDropdown={invalid}
            showAction
            classParentList="arh-mb-[0.75rem]"
          />
        </>
      )}
    />
  );
}
